export default "__VITE_ASSET__zafKL0wW__"